import { Box, useTheme } from '@mui/material';
import { maxWidth345CenteredSx } from '../../styles/Global.style';
import { Heading } from '../Heading/Heading';
import { Chart } from '../Chart/Chart';
import { mapTrendsChartData } from '../../helpers/mapTrendsChartData';
import { Copy } from '../../copy/Copy';

export const Trends = ({ activities }) => {
  const theme = useTheme();

  const { series, xAxis, yAxis } = mapTrendsChartData(theme, activities);

  return (
    <Box component="section" sx={maxWidth345CenteredSx}>
      <Heading
        text={Copy.generate('Trends.heading')}
        color={theme.palette.secondary.main}
        level={1}
      />

      <Chart
        name="trends"
        series={series}
        xAxis={xAxis}
        yAxis={yAxis}
        xLabel={Copy.generate('Trends.xLabel')}
      />
    </Box>
  );
};
